<template>
  <div class="form-group">
    <label
      v-if="label"
      :for="name"
      class="control-label"
    >
      {{label}}:
    </label>
    <div class="input-group">
      <input
        :id="name"
        class="form-control"
        type="text"
        :name="name"
        :value="value"
        @input="change"
        @keyup="keyup"
        :maxlength="maxlength || 50"
        :placeholder="placeholder || label"
        :disabled="disabled"
        :readonly="readonly"
      />
      <div class="input-group-append">
        <div
          class="input-group-text"
          style="cursor: pointer"
          @click="clearSearch()"
        >
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
let _wait = 750
export default {
  name: 'dt-search',
  props: {
    name: String,
    wait: Number,
    value: String,
    label: String,
    vvalidate: String,
    disabled: Boolean,
    readonly: Boolean,
    maxlength: Number,
    placeholder: String
  },
  created() {
    _wait = this.wait || 750
  },
  methods: {
    change($event) {
      this.$emit('input', $event.target.value)
    },
    keyup: debounce(function($event) {
      this.$emit('keyup', $event.target.value)
    }, _wait),
    clearSearch() {
      this.$emit('input', '')
      this.$emit('keyup', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-search.vue